module.exports = __webpack_public_path__ + "static/media/frosting_gun.f5deb850.cur";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/sprites/cursors/frosting_gun.cur
// module id = 2625
// module chunks = 0